'use client';

import { motion } from 'framer-motion';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Button } from 'shared/ui/button';
export function ChangeTheme({
  menuItem = false
}: {
  menuItem?: boolean;
}) {
  const {
    theme,
    setTheme
  } = useTheme();
  // const [customTheme, setCustomTheme] = useState(theme);

  const handleChange = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };
  //
  // useEffect(() => {
  //   if (!theme) return;
  //   setCustomTheme(theme);
  // }, [theme]);

  if (menuItem) return <Button variant="ghost" className="w-full justify-between" onClick={handleChange} asChild>
        <div className="flex w-full items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="relative size-4">
              <motion.div initial={false} animate={{
            scale: theme === 'dark' ? 1 : 0,
            opacity: theme === 'dark' ? 1 : 0
          }} transition={{
            duration: 0.3
          }} className="absolute flex items-center justify-center">
                <Moon className="size-4 fill-blue-700 text-blue-700" />
              </motion.div>
              <motion.div initial={false} animate={{
            scale: theme === 'light' ? 1 : 0,
            opacity: theme === 'light' ? 1 : 0
          }} transition={{
            duration: 0.3
          }} className="absolute  flex items-center justify-center">
                <Sun className="size-4 text-yellow-500" />
              </motion.div>
            </div>
            <span className="">Theme Mode:</span>
          </div>
          <span className="">{theme === 'dark' ? 'Темная' : 'Светлая'}</span>
        </div>
      </Button>;
  return <Button variant="ghost" size="sm" onClick={handleChange} aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`} className="relative size-8 rounded-full" suppressHydrationWarning data-sentry-element="Button" data-sentry-component="ChangeTheme" data-sentry-source-file="ChangeTheme.tsx">
      <motion.div initial={false} animate={{
      scale: theme === 'light' ? 1 : 0,
      opacity: theme === 'light' ? 1 : 0
    }} transition={{
      duration: 0.3
    }} className="absolute inset-0 flex items-center justify-center" data-sentry-element="unknown" data-sentry-source-file="ChangeTheme.tsx">
        <Moon className="size-5 fill-blue-700 text-blue-700" data-sentry-element="Moon" data-sentry-source-file="ChangeTheme.tsx" />
      </motion.div>
      <motion.div initial={false} animate={{
      scale: theme === 'dark' ? 1 : 0,
      opacity: theme === 'dark' ? 1 : 0
    }} transition={{
      duration: 0.3
    }} className="absolute inset-0 flex items-center justify-center" data-sentry-element="unknown" data-sentry-source-file="ChangeTheme.tsx">
        <Sun className="size-5 text-yellow-500" data-sentry-element="Sun" data-sentry-source-file="ChangeTheme.tsx" />
      </motion.div>
    </Button>;
}